import { setTrackingId } from "client/Misc/utils";
import { PropsWithChildren, ReactElement } from "react";
import styles from "./ScopeSection.module.less";

export type ScopeSectionProps = {
	title: string;
	titleAction?: ReactElement;
	trackingId: string;
};

export const ScopeSection = (props: PropsWithChildren<ScopeSectionProps>): ReactElement => {
	const {
		title,
		titleAction,
		trackingId,
		children
	} = props;

	return (
		<div
			{...setTrackingId(trackingId)}
			className={styles.section}
		>
			<div className={styles.header}>
				<h4
					{...setTrackingId("name")}
					className={styles.title}
					title={title}
				>
					{title}
				</h4>
				<hr className={styles.line} />
				{titleAction && (
					<div className={styles.titleAction}>
						{titleAction}
					</div>
				)}
			</div>
			{children}
		</div>
	);
};
ScopeSection.displayName = "ScopeSection";